var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOddsSearch = function SvgOddsSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51.519,
    height: 30.787,
    viewBox: "0 0 51.519 30.787",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12032",
    "data-name": "Group 12032",
    transform: "translate(-14 -346)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 51.519,
    height: 30.787,
    rx: 15,
    transform: "translate(14 346)",
    fill: "#0f40a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M17.553,15.873l-4.148-4.314A7.033,7.033,0,1,0,8.02,14.072,6.961,6.961,0,0,0,12.051,12.8l4.179,4.346a.918.918,0,1,0,1.323-1.272ZM8.02,1.835a5.2,5.2,0,1,1-5.2,5.2A5.206,5.206,0,0,1,8.02,1.835Z",
    transform: "translate(30.262 352.196)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOddsSearch, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MS41MTkiIGhlaWdodD0iMzAuNzg3IiB2aWV3Qm94PSIwIDAgNTEuNTE5IDMwLjc4NyI+CiAgPGcgaWQ9Ikdyb3VwXzEyMDMyIiBkYXRhLW5hbWU9Ikdyb3VwIDEyMDMyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQgLTM0NikiPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV83ODMiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDc4MyIgd2lkdGg9IjUxLjUxOSIgaGVpZ2h0PSIzMC43ODciIHJ4PSIxNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQgMzQ2KSIgZmlsbD0iIzBmNDBhOSIvPgogICAgPHBhdGggaWQ9InNlYXJjaCIgZD0iTTE3LjU1MywxNS44NzNsLTQuMTQ4LTQuMzE0QTcuMDMzLDcuMDMzLDAsMSwwLDguMDIsMTQuMDcyLDYuOTYxLDYuOTYxLDAsMCwwLDEyLjA1MSwxMi44bDQuMTc5LDQuMzQ2YS45MTguOTE4LDAsMSwwLDEuMzIzLTEuMjcyWk04LjAyLDEuODM1YTUuMiw1LjIsMCwxLDEtNS4yLDUuMkE1LjIwNiw1LjIwNiwwLDAsMSw4LjAyLDEuODM1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzAuMjYyIDM1Mi4xOTYpIiBmaWxsPSIjZmZmIi8+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };